import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const Drag = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        d='M8 3C8 4.10455 7.10458 5 6 5C4.89545 5 4 4.10458 4 3C4 1.89545 4.89542 1 6 1C7.10455 1 8 1.89542 8 3Z'
        fill={color}
      />
      <path
        d='M16 3C16 4.10455 15.1046 5 14 5C12.8955 5 12 4.10458 12 3C12 1.89545 12.8954 1 14 1C15.1045 1 16 1.89542 16 3Z'
        fill={color}
      />
      <path
        d='M6 12C7.10458 12 8 11.1045 8 10C8 8.89542 7.10455 8 6 8C4.89542 8 4 8.89542 4 10C4 11.1046 4.89545 12 6 12Z'
        fill={color}
      />
      <path
        d='M16 10C16 11.1045 15.1046 12 14 12C12.8955 12 12 11.1046 12 10C12 8.89542 12.8954 8 14 8C15.1045 8 16 8.89542 16 10Z'
        fill={color}
      />
      <path
        d='M8 17C8 18.1045 7.10458 19 6 19C4.89545 19 4 18.1046 4 17C4 15.8955 4.89542 15 6 15C7.10455 15 8 15.8954 8 17Z'
        fill={color}
      />
      <path
        d='M16 17C16 18.1045 15.1046 19 14 19C12.8955 19 12 18.1046 12 17C12 15.8955 12.8954 15 14 15C15.1045 15 16 15.8954 16 17Z'
        fill={color}
      />
    </svg>
  );
};
